import { useEffect, useState } from "react";
import { HashRouter } from "react-router-dom";
import { MyStorage } from "./Context/MyContext";
import Menu from "./Forms/Menu";
import { Router } from "./Components/Router";
import { DashboardData } from "./Context/DashboardAlternadoContext";
import { PedidosData } from "./Context/PedidosContext";
import { Manutencao } from "./Components/Manutencao";
import { getManutencao, subscribeManutencao } from "./Api/manutencaoStore";

function App() {
  const [emManutencao, setEmManutencao] = useState(getManutencao());

  useEffect(() => subscribeManutencao(setEmManutencao), []);

  if (emManutencao) {
    return <Manutencao />;
  }

  return (
    <HashRouter>
      <PedidosData>
        <MyStorage>
            <DashboardData>
              <Menu />
              <Router />
          </DashboardData>
        </MyStorage>
      </PedidosData>
    </HashRouter>
  );
}

export default App;
